<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right" v-if="typeImport">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="insertData()"
            >
              <v-icon left>mdi-file-import</v-icon>
              นำข้อมูลเข้าฐานข้อมูล
            </v-btn>
            <v-btn
              color="error"
              depressed
              dark
              @click="RemoveInsert()"
            >
              <v-icon left>mdi-card-remove-outline</v-icon>
              ยกเลิก
            </v-btn>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right" v-if="typeImport === ''">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="(dialogSelect = true), validate('ImportApi'), getDataApi()"
            >
              <v-icon left>mdi-database-import</v-icon>
              นำข้อมูลเข้า API
            </v-btn>
            <v-btn
              color="#1B437C"
              dark
              depressed
              @click="(dialogImportExcel = true), validate('ImportExcel')"
            >
              <v-icon left>mdi-table-arrow-right</v-icon>
              นำเข้าข้อมูล Excel
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row justify="center" no-gutters>
              <v-col cols="3">
                <v-alert
                  dense
                  border="left"
                  type="warning"
                >
                  จำนวนทั้งหมด : <strong>{{full}}</strong>
                </v-alert>
              </v-col>
              <v-col cols="1"></v-col>
              <v-col cols="3">
                <v-alert
                  dense
                  border="left"
                  type="success"
                >
                  จำนวนเหรียญที่แจกได้ : <strong>{{sussec}}</strong>
                </v-alert>
              </v-col>
            </v-row>
          </v-col>
          <v-col  v-if="typeImport" cols="12" class="text-center">
            <h5 style="color: red;">*** กรุณากดปุ่ม นำข้อมูลเข้า ฐานข้อมูล ***</h5>
          </v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="columns"
                    :items="datareport"
                    :items-per-page="100"
                    dense
                  >
                  </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogImportExcel" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">นำเข้าข้อมูล</span>
              </v-card-title>
              <v-form
                ref="form_importExcel"
                v-model="validImportExcel"
                lazy-validation
              >
                <v-card-text v-if="!showStatus">
                  <v-container>
                    <v-row>
                      <!-- <v-col cols="12">
                        <input
                          type="file"
                          @change="importData"
                          accept=".xls,.xlsx"
                        />
                      </v-col> -->
                      <v-col cols="12">
                         <v-btn class="btn-color" dark>
                        <v-icon left>mdi-download</v-icon>
                          <download-excel
                            class="btn btn-default"
                            :data="export_datas"
                            :fields="export_fields"
                            :type="exportType"
                            :worksheet="exportWorksheet"
                            :name="exportFileName"
                          >
                            Download Template
                          </download-excel>
                         </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-text v-if="!showStatus">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <v-data-table
                            v-if="columnsImportUse"
                            :headers="columnsImport"
                            :items="dataItemImport"
                            :items-per-page="50"
                          ></v-data-table>
                          <v-data-table
                            v-if="!columnsImportUse"
                            :headers="columnsMerge"
                            :items="dataItemImport"
                            :items-per-page="50"
                          >
                            <template v-slot:[`item.color`]="{ item }">
                              <v-chip
                                  class="ma-2"
                                  color="success"
                                  v-if="item.color == 'green'"
                              >
                                  <v-icon left>
                                  mdi-server-plus
                                  </v-icon>
                                  เข้ากัน
                              </v-chip>
                              <v-chip
                                  class="ma-2"
                                  color="error"
                                  v-if="item.color == 'red'"
                              >
                                  <v-icon left>
                                  mdi-close-network
                                  </v-icon>
                                  ไม่เข้าเข้ากัน
                              </v-chip>
                          </template>
                          </v-data-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-text v-if="showStatus">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                      <v-progress-linear
                        v-model="valueLoad"
                        height="25"
                      >
                        <strong>{{ Math.ceil(valueLoad) }}%</strong>
                      </v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    dark
                    color="red darken-1"
                    @click="(dialogImportExcel = false), RemoveInsert()"
                  >
                    ปิด
                  </v-btn>
                  <template v-if="!dataItemImportChecKHide">
                    <v-btn
                      elevation="2"
                      v-if="columnsImportUse"
                      color="1b437c"
                      dark
                      :disabled="!validImportExcel"
                      @click="importDataApprove('add')"
                    >
                      นำเข้าข้อมูล
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogSelect" persistent max-width="50%">
            <v-card>
              <v-card-title>
                <span class="headline">นำเข้าข้อมูล</span>
              </v-card-title>
              <v-form
                ref="form_importapi"
                v-model="validImportApi"
                lazy-validation
              >
                <v-card-text v-if="!showStatus">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="urlApi"
                          :items="dataApi"
                          dense
                          :rules="[rules.required]"
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="dateApi"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dateApi"
                              label="Picker in dialog"
                              prepend-icon="mdi-calendar"
                              readonly
                              :rules="[rules.required]"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateApi"
                            scrollable
                            @change="$refs.dialog.save(dateApi)"
                          >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-text v-if="showStatus">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                      <v-progress-linear
                        v-model="valueLoad"
                        height="25"
                      >
                        <strong>{{ Math.ceil(valueLoad) }}%</strong>
                      </v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    color="red"
                    dark
                    @click="(dialogSelect = false)"
                  >
                    ปิด
                  </v-btn>
                    <v-btn
                      elevation="2"
                      dark
                      :disabled="!validImportApi"
                      class="btn-color"
                      @click="onSearch()"
                    >
                      นำเข้าข้อมูล
                    </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      valueLoad: 0,
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      session: this.$session.getAll(),
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Import Point',
          disabled: false,
          href: '/Tool/GivePointM'
        }
      ],
      exportType: 'xls',
      exportFileName: 'Template.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        date_input: 'date_input',
        order_No: 'order_No',
        branch: 'branch',
        service: 'service',
        amount: 'amount',
        refId: 'refId'
      },
      export_datas: [
        {
          date_input: '',
          order_No: '',
          branch: '',
          service: '',
          amount: '',
          refId: ''
        }
      ],
      columnsImportUse: false,
      columnsImport: [
        { text: 'รหัสอ้างอิง', value: 'refId' },
        { text: 'เลขที่ใบสั่ง', value: 'order_No' },
        { text: 'สาขา', value: 'branch' },
        { text: 'บริการ', value: 'service' },
        { text: 'จำนวนเงิน', value: 'amount' }
      ],
      columns: [],
      columnsExcel: [
        { text: 'รหัสอ้างอิง', value: 'refId' },
        { text: 'เลขที่ใบสั่ง.', value: 'order_No' },
        { text: 'สาขา', value: 'branchName' },
        { text: 'บริการ', value: 'service' },
        { text: 'จำนวนเงิน', value: 'amount' },
        { text: 'Coin', value: 'coin' }
      ],
      columnsService: [
        { text: 'Reference Id', value: 'refId' },
        { text: 'Order No.', value: 'order_No' },
        { text: 'สาขา', value: 'branchName' },
        { text: 'บริการ', value: 'service' },
        { text: 'จำนวนเงิน', value: 'amount' },
        { text: 'Coin', value: 'coin' }
      ],
      // columnsService: [
      //   { text: 'คะแนน', value: 'coin' },
      //   { text: 'สาขา', value: 'Dlr_Code' },
      //   { text: 'ประเภท Job', value: 'jOB_income' },
      //   { text: 'JOB_Type', value: 'JOB_Type' },
      //   // { text: 'DocHead', value: 'DocHead' },
      //   { text: 'Frame_no', value: 'Frame_no' },
      //   { text: 'reg_no', value: 'reg_no' },
      //   { text: 'job_num', value: 'job_num' },
      //   { text: 'job_date', value: 'job_date' },
      //   { text: 'Total_AMT', value: 'Total_AMT' }
      // ],
      datareport: [],
      dataItemImport: [],
      typeImport: '',
      dateApi: '',
      validImportExcel: true,
      validImportApi: true,
      dataItemImportChecKHide: true,
      dataExchange: [],
      dataBranch: [],
      dataApi: [],
      modal: false,
      dialogImportExcel: false,
      dialogSelect: false,
      urlApi: '',
      dataUse: [],
      showStatus: false,
      full: 0,
      sussec: 0,
      dataBetask: ['date_input', 'order_No', 'branch', 'service', 'amount', 'refId'],
      columnsMerge: [
        { text: 'Schema', value: 'text' },
        { text: 'Merge', value: 'color' }
      ]
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    console.log(this.export_datas)
    await this.getExchange()
    await this.getDataBranch()
  },
  methods: {
    async getDataApi () {
      // Clear Data ทุกครั้ง
      this.dataApi = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/givePointApi/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.urlApi
            s.text = d.urlApi
            d = s
            this.dataApi.push(d)
          }
          console.log('dataApi : ', this.dataApi)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          console.log(error)
        })
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/" + "get?shopId=" + this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataBranch = response.data
          console.log(this.dataBranch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getExchange () {
      this.dataExchange = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/productExchangeRate/get?shopId=" + this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataExchange = response.data
          console.log(this.dataExchange)
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ImportExcel':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_importExcel.validate()
          })
          break
        case 'ImportApi':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_importapi.validate()
          })
          break

        default:
          break
      }
    },
    async importData (event) {
      this.showStatus = false
      var input = event.target
      this.full = 0
      this.sussec = 0
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(async sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log(rowObj)
          this.checkImportExcel(rowObj)
          if (rowObj.length === 0) {
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
            this.full = 0
            this.sussec = 0
          } else {
            this.full = rowObj.length
            this.sussec = 0
            this.dataItemImportChecKHide = false
          }
        })
      }
      reader.readAsBinaryString(input.files[0])
      // if (this.chkReader) {
      //   reader.readAsBinaryString(input.files[0])
      // }
    },
    checkImportExcel (dataImport) {
      this.columnsImportUse = false
      var dataApi = Object.keys(dataImport[0])
      var useData = []
      for (var i = 0; i < this.dataBetask.length; i++) {
        var d = this.dataBetask[i]
        var s = {}
        var chkArr = dataApi.filter(function (val) {
          return d === val
        })
        var colors = ''
        if (chkArr.length > '') {
          colors = 'green'
        } else {
          colors = 'red'
        }
        s.color = colors
        s.text = d
        useData.push(s)
      }
      var checkData = useData.filter(function (val) {
        return val.color === 'red'
      })
      this.dataMerge = useData
      if (checkData.length > 0) {
        this.$swal('ผิดพลาด', 'เนื่องจากมี schema ที่ไม่ตรงกัน', 'error')
        this.dataItemImport = useData
        this.columnsImportUse = false
      } else {
        this.dataItemImport = dataImport
        this.columnsImportUse = true
      }
      console.log(useData)
    },
    async importDataApprove (action) {
      var checkError = false
      this.valueLoad = 0
      this.columns = []
      var pushData = []
      // this.full = rowObj.length
      this.sussec = 0
      var codeOrders = this.generateCodeGlobal()
      for (var key in this.dataItemImport) {
        if (action === 'add') {
          var e = this.dataItemImport[key]
          this.showStatus = true
          this.valueLoad = (key / this.dataItemImport.length) * 100
          var url = this.DNS_IP + '/givePoints/get?dateInput=' + this.momenDate_1(e.date_input) + '&orderNo=' + e.order_No + '&shopId=' + this.session.data.shopId
          await axios
            .get(
              url
            )
            .then(async (response) => {
              console.log(response)
              if (response.data.status === false) {
                e.branchName = e.branch
                var masBranchID = 0
                var productExchangeRateId = 0
                var dataCheckBranch = this.dataBranch.filter(await function (el) {
                  return el.masBranchName === e.branch
                })
                var dataCheckExchang = this.dataExchange.filter(await function (el) {
                  return el.name === e.service
                })
                if (dataCheckBranch.length > 0) {
                  masBranchID = dataCheckBranch[0].masBranchID
                } else {
                  masBranchID = 0
                }
                var point = 0
                if (dataCheckExchang.length > 0) {
                  productExchangeRateId = dataCheckExchang[0].productExchangeRateId
                  point = parseInt(e.amount) / dataCheckExchang[0].exchangeRate
                } else {
                  productExchangeRateId = 0
                  point = 0
                }
                if (point > 0) {
                  e.coin = point
                  e.codeOrder = codeOrders
                  let dt =
                "('" +
                e.codeOrder +
                "','" +
                this.momenDate_1(e.date_input) +
                "','" +
                e.order_No +
                "','" +
                e.service +
                "','" +
                e.branch +
                "'," +
                masBranchID +
                ',' +
                productExchangeRateId +
                ",'" +
                point +
                "','" +
                e.amount +
                "','" +
                e.refId.toString().trim() +
                "','" +
                'wait' +
                "','" +
                'N' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "','" +
                this.session.data.shopId +
                "')"
                  pushData.push(dt)
                  this.datareport.push(e)
                  checkError = true
                }
              }
            })
        }
      }
      console.log(pushData)
      if (checkError === true) {
        var usedata = pushData.map(function (pushBookingNums) {
          return decodeURIComponent(pushBookingNums)
        })
        console.log(this.datareport)
        this.columns = this.columnsExcel
        this.typeImport = 'excel'
        this.dialogImportExcel = false
        this.dataUse = usedata
        this.showStatus = false
        this.sussec = usedata.length
      } else {
        this.sussec = 0
        this.dataItemImport = []
        this.dataItemImportChecKHide = true
        this.dialogImportExcel = false
        this.dataUse = []
        this.datareport = []
        this.showStatus = false
        // alert('โปรดใส่ไฟล์ให้ถูกต้อง')
        this.$swal('ผิดพลาด', 'ข้อมูลที่ท่านนำเข้ามีในระบบอยู่แล้ว', 'error')
      }
    },
    onSearch () {
      this.showStatus = false
      this.valueLoad = 0
      this.columns = []
      this.datareport = []
      this.dataSearhcReady = false
      this.dataSearhcReadyTable = false
      let url = ''
      this.full = 0
      this.sussec = 0
      this.columnsUse = this.columnsService
      var codeOrders = this.generateCodeGlobal()
      url = this.urlApi + '?date_input=' + this.dateApi
      axios
        .get(
          url
        )
        .then(async (response) => {
          // console.log(response)
          let rs = response.data
          if (rs.length > 0) {
            var dataApi = Object.keys(rs[0])
            var useData = []
            for (var i = 0; i < this.dataBetask.length; i++) {
              var d = this.dataBetask[i]
              var s = {}
              var chkArr = dataApi.filter(function (val) {
                return d === val
              })
              var colors = ''
              if (chkArr.length > '') {
                colors = 'green'
              } else {
                colors = 'red'
              }
              s.color = colors
              s.text = d
              useData.push(s)
            }
            var checkData = useData.filter(function (val) {
              return val.color === 'red'
            })
            // this.dataMerge = useData
            if (checkData.length > 0) {
              this.$swal('ผิดพลาด', 'เนื่องจากมี schema ที่ไม่ตรงกัน', 'error')
            } else {
              var pushData = []
              this.full = rs.length
              for (var x = 0; x < rs.length; x++) {
                var e = rs[x]
                var url1 = this.DNS_IP + '/givePoints/get?dateInput=' + this.momenDate_1(e.date_input) + '&orderNo=' + e.order_No + '&shopId=' + this.session.data.shopId
                await axios
                  .get(
                    url1
                  )
                  .then(async (response) => {
                    console.log(response)
                    if (response.data.status === false) {
                      e.branchName = e.branch
                      var masBranchID = 0
                      var productExchangeRateId = 0
                      var dataCheckBranch = this.dataBranch.filter(await function (el) {
                        return el.masBranchName === e.branch
                      })
                      var dataCheckExchang = this.dataExchange.filter(await function (el) {
                        return el.name === e.service
                      })
                      if (dataCheckBranch.length > 0) {
                        masBranchID = dataCheckBranch[0].masBranchID
                      } else {
                        masBranchID = 0
                      }
                      var point = 0
                      if (dataCheckExchang.length > 0) {
                        productExchangeRateId = dataCheckExchang[0].productExchangeRateId
                        point = parseInt(e.amount) / dataCheckExchang[0].exchangeRate
                      } else {
                        productExchangeRateId = 0
                        point = 0
                      }
                      if (point > 0) {
                        e.coin = point
                        e.codeOrder = codeOrders
                        let dt =
                "('" +
                e.codeOrder +
                "','" +
                this.momenDate_1(e.date_input) +
                "','" +
                e.order_No +
                "','" +
                e.service +
                "','" +
                e.branch +
                "'," +
                masBranchID +
                ',' +
                productExchangeRateId +
                ",'" +
                point +
                "','" +
                e.amount +
                "','" +
                e.refId.toString().trim() +
                "','" +
                'wait' +
                "','" +
                'N' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "','" +
                this.session.data.shopId +
                "')"
                        pushData.push(dt)
                        this.datareport.push(e)
                      }
                    }
                  })
              }

              // this.datareport = rs
              var usedata = pushData.map(function (pushBookingNums) {
                return decodeURIComponent(pushBookingNums)
              })
              console.log(this.datareport)
              if (this.datareport.length > 0) {
                this.columns = this.columnsService
                this.dialogSelect = false
                this.typeImport = 'api'
                this.dataUse = usedata
                this.showStatus = false
                this.sussec = usedata.length
              } else {
                this.dataUse = []
                this.datareport = []
                this.dialogSelect = false
                this.typeImport = ''
                this.showStatus = false
                this.sussec = 0
                this.$swal('ผิดพลาด', 'ข้อมูลที่ท่านนำเข้ามีในระบบอยู่แล้ว', 'error')
              }
            }
          } else {
            this.$swal('ผิดพลาด', 'ไม่มีข้อมูลในระบบ', 'error')
          }
        })
    },
    RemoveInsert () {
      this.dataUse = []
      this.datareport = []
      this.dialogSelect = false
      this.typeImport = ''
      this.showStatus = false
      this.dataItemImport = []
      this.dataItemImportChecKHide = true
      this.dialogImportExcel = false
      this.dataUse = []
      this.datareport = []
      this.showStatus = false
      this.full = 0
      this.sussec = 0
    },
    async insertData () {
      console.log(this.typeImport)
      this.$swal({
        title: 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          if (this.typeImport === 'api') {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/givePoints/addMulti",
                this.dataUse
              )
              .then(async response => {})
            var config = {
              method: 'post',
              url: this.DNS_IP + '/vgroupMapping/updateCoinVgroup',
              headers: {
                'shopId': this.session.data.shopId,
                'codeOrder': this.datareport[0].codeOrder
              },
              data: this.datareport
            }
            await axios(config)
              .then(async response => {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูลสำเร็จ', 'success')
                this.RemoveInsert()
              })
          } else if (this.typeImport === 'excel') {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/givePoints/addMulti",
                this.dataUse
              )
              .then(async response => {
              })
            var config1 = {
              method: 'post',
              url: this.DNS_IP + '/vgroupMapping/updateCoinVgroup',
              headers: {
                'shopId': this.session.data.shopId,
                'codeOrder': this.datareport[0].codeOrder
              }
            }
            await axios(config1)
              .then(async response => {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูลสำเร็จ', 'success')
                this.RemoveInsert()
              })
          }
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tool/GivePointM.vue